import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetInsertAttribute = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);

  const getInsertRequest = (
    guid,
    setAttrValue,
    // eslint-disable-next-line max-params
  ) => {
    axiosClient
      .get(`SettingProduct/CoddingAttribute/Insert?guid=${guid}`)
      .then(res => {
        if (res.status === 200) {
          setAttrValue(res.data?.value?.value);
        } else {
          enqueueSnackbar(res?.data?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };
  return [getInsertRequest, loading];
};

export default useGetInsertAttribute;
